import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const GoogleAuthButton = ({ signin, signup, setError }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    ux_mode: 'redirect',
    redirect_uri: 'https://makersharks.com/oauth/google/callback',
    onError: (errorResponse) => {
      console.log(errorResponse);
      setError(
        errorResponse || 'An error occurred during google authentication',
      );
    },
  });

  return (
    <div>
      <button
        className="flex w-full items-center justify-center rounded-lg border-[1px] border-gray-300 px-4 py-2 text-[15px] text-left text-black focus:outline-none hover:border-lightPurple transition ease-in-out duration-300 "
        onClick={() => googleLogin()}
      >
        <img
          alt="googleLogo"
          src="/google_logo.svg"
          className={`w-6 h-6 ${(signin || signup) && 'mr-4'}`}
        />
        {(signin || signup) && (
          <span className="text-gray-500 font-semibold hover:text-darkerPurple transition ease-in-out duration-300 ">
            {signin && 'Login with Google'}
            {signup && 'Sign Up with Google'}
          </span>
        )}
      </button>
    </div>
  );
};

export default GoogleAuthButton;
